export default __webpack_public_path__ + "static/media/uploader-abbottLite-4.c4fa44ce.png";